import axios from 'axios';
import { etransferEvents } from '@etransfer/utils';
import { isDeniedRequest } from './utils.js';
const axiosInstance = axios.create({
    baseURL: '/',
    timeout: 20000,
});
axiosInstance.interceptors.request.use(config => {
    return config;
}, error => {
    Promise.reject(error);
});
axiosInstance.interceptors.response.use(response => {
    var _a;
    const res = response.data;
    if ((res === null || res === void 0 ? void 0 : res.code) && ((_a = res === null || res === void 0 ? void 0 : res.code) === null || _a === void 0 ? void 0 : _a.substring(0, 1)) !== '2') {
        return Promise.reject(res);
    }
    if (res === null || res === void 0 ? void 0 : res.code) {
        return res;
    }
    else {
        return { data: res };
    }
}, error => {
    if (isDeniedRequest(error)) {
        etransferEvents.DeniedRequest.emit();
    }
    return Promise.reject(error);
});
export const baseRequest = axiosInstance;
